export const spaceThemeToken: any = {};
